import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { urlAssets, urlEspecial } from '../../Constants';

//components
import Shield from './Shield';
import TextTeam from './TextTeam';
import Crack from './Crack';
import TagTeam from './TagTeam';
import Match from './Match';
import WorldChampionships from './WorldChampionships';
import Appearances from './Appearances';
import ReturnHome from './ReturnHome';

const QualifiedTeam = props => {

    const { appearances, bckgColor, championships, crack, match, name, slug, text } = props.team;   

    return (
        <Fragment>
            <Shield bckgColor={bckgColor} name={name} slug={slug} urlAssets={urlAssets} />
            <TextTeam text={text} />
            <TagTeam bckgColor={bckgColor} subtitle="El crack"/>
            <Crack crack={crack} slug={slug} urlAssets={urlAssets} />
            <TagTeam bckgColor={bckgColor} subtitle="Partido de clasificación"/>
            <Match match={match} slug={slug} urlAssets={urlAssets} />
            <TagTeam bckgColor={bckgColor} subtitle="Participaciones"/>
            <Appearances appearances={appearances} />
            { championships &&
                <Fragment>
                    <TagTeam bckgColor={bckgColor} subtitle="Títulos Mundiales"/>
                    <WorldChampionships championships={championships} />
                </Fragment>
            }       
            <ReturnHome bckgColor={bckgColor} urlEspecial={urlEspecial} />     
        </Fragment>
    )
}

export default QualifiedTeam;

QualifiedTeam.propTypes = {
    team: PropTypes.object.isRequired
}
